import { render } from "./CreateBlogPost.vue?vue&type=template&id=15a26c71&scoped=true"
import script from "./CreateBlogPost.vue?vue&type=script&lang=js"
export * from "./CreateBlogPost.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=15a26c71&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a26c71"]])

export default __exports__